export const COOKIE_CONSENT_STORAGE_KEY = "anylex_cookie_consent";
export const COOKIE_CONSENT_UPDATED_EVENT = "anylex:cookie-consent-updated";
export const COOKIE_CONSENT_OPEN_SETTINGS_EVENT = "anylex:open-cookie-settings";

const COOKIE_CONSENT_EXPIRY_DAYS = 30;

function isBrowser() {
  return typeof window !== "undefined";
}

function parseStoredConsent(rawValue) {
  if (!rawValue) {
    return null;
  }

  try {
    return JSON.parse(rawValue);
  } catch (error) {
    return null;
  }
}

export function isCookieConsentValid(consent) {
  if (!consent?.timestamp) {
    return false;
  }

  const consentTime = new Date(consent.timestamp).getTime();
  if (!Number.isFinite(consentTime)) {
    return false;
  }

  const now = Date.now();
  const ageMs = now - consentTime;
  const maxAgeMs = COOKIE_CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000;

  return ageMs >= 0 && ageMs < maxAgeMs;
}

export function readCookieConsent() {
  if (!isBrowser()) {
    return null;
  }

  const stored = parseStoredConsent(
    window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY)
  );

  if (!isCookieConsentValid(stored)) {
    return null;
  }

  return {
    accepted: true,
    necessary: true,
    analytics: Boolean(stored?.analytics),
    marketing: Boolean(stored?.marketing),
    timestamp: stored.timestamp,
  };
}

export function persistCookieConsent(selection) {
  if (!isBrowser()) {
    return null;
  }

  const normalized = {
    accepted: true,
    necessary: true,
    analytics: Boolean(selection?.analytics),
    marketing: Boolean(selection?.marketing),
    timestamp: new Date().toISOString(),
  };

  window.localStorage.setItem(
    COOKIE_CONSENT_STORAGE_KEY,
    JSON.stringify(normalized)
  );
  window.dispatchEvent(
    new CustomEvent(COOKIE_CONSENT_UPDATED_EVENT, {
      detail: normalized,
    })
  );

  return normalized;
}

export function openCookieSettings() {
  if (!isBrowser()) {
    return;
  }

  window.dispatchEvent(new Event(COOKIE_CONSENT_OPEN_SETTINGS_EVENT));
}
